import BootstrapModal from "../../components/BootstrapModal";
import {Formik, Form, Field} from 'formik'
import TextField from "../../components/TextField";
import * as Yup from 'yup'
import PMSCheckBox from "../../components/PMSCheckBox";
import FormSelect from "../../components/FormSelect";
import {ProgressSpinner} from "primereact/progressspinner";

const UserRoleNamesForm = ({modal,activeUserRole,designationNames, userRoleNameID,userRoleID,designationID,roleTitle,active, isLoading, onSubmit, onHide}) => {
    const validation = Yup.object({
        userRoleID:  Yup.number().positive('Please Select User Role'),
        designationID:  Yup.number().positive('Please Select Role Title'),
        //roleTitle: Yup.string().required('Role Title is Required'),
    })

    return (<>
        <BootstrapModal headerText="Add User Wise Role" size={30} visible={modal} onHide={onHide}>
            <Formik
                validationSchema={validation}
                initialValues={{userRoleNameID: userRoleNameID,userRoleID: userRoleID,designationID: designationID, roleTitle: roleTitle, active: active}}
                onSubmit={onSubmit}>
                {formik =>
                    (<>
                        <Form>
                            <Field type="hidden" name="userRoleNameID"/>
                            <FormSelect label={'Role Type'} id="userRoleID" name="userRoleID" options={activeUserRole}/>
                            <FormSelect label={'Designation'} id="designationID" name="designationID" options={designationNames}/>                            
                            <PMSCheckBox name={'active'} id={'active'}/>
                            {isLoading ? <ProgressSpinner style={ {height:30,width:30} }/> : <button type="submit" disabled={isLoading} className="btn btn-primary">{userRoleNameID === 0 ? 'Save' : 'Update'} </button>}
                            <TextField label={''} type="hidden" name="roleTitle"  />
                        </Form>
                    </>)}

            </Formik>

        </BootstrapModal>

    </>)
}

export default UserRoleNamesForm